
const BuyerServicesUrl = {
 //Auth
  Login: "user/auth/login",
  Register: "user/auth/register",
  LogOut:"user/auth/logout",
  ChangePassword: "user/auth/change-password",
  ForgetPassword: "user/auth/forget-password",
  ResetPassword: "user/auth/reset-password",
 
  // notifications
  Notifications: "register-device-token",
  GetNotifications:"notifications",
  GetReadNotification:"read-notifications",
  GetCountNotification:"count-unread-notifications",
  // DeleteNotification:"delete-notifications/{id}",
  DeleteNotification: "delete-notifications",
  //categories
  GetCategory: "user/categories",
  //Product
  GetProductList: "user/geust/products",
  GetProductsFavoriteList: "user/products-favorite",
  // GetProductById: "user/products/{id}",
  GetProductById : "user/geust/products/{id}",

  RateProduct:"user/products/{id}/add-rate",
  AddProductToFavorites:"user/products/{id}/favorite",
  // Marketing 
  Marketing: "user/marketing",
  // Support
GetAllCharity: "user/get-charity",
//Home
// Home:"user/home",
Home: "user/home-page",
// Category
GetCategories: "user/categories",
GetCategoryByName:"user/products-byCategory",
// support
 GetCharity: "user/get-charity",
  GetKindSupport: "user/get-kind-support",
  SendSupportRequest: "user/send-support",
 //marketing
  // marketing ✅
GetMarketingData: "user/get-markting-data",
SendMarketingRequest: "user/send-markting-request",
// Orders
MyOrders: "user/my-order",
//orders details
OrderDetails: "user/my-order-details",
//cart 
AddToCart:"user/add-to-cart",
ShowCart:"user/show-my-cart",
ChangeCart:"user/change-cart",
RemoveCart:"user/remove-from-cart",
//Adds
AddAdvertisement:"user/products/create-ad",
ShowAdvertisements:"user/products-my-ads",
UpdateAdvertisement:"user/products/update-ad/{id}",

// DeleteAdvertisement:"user/delete-ad/{id}",

AddImageAds: "user/add-image-ads/{id}",
EditImageAds: "user/edit-image-ads/{id}",
DeleteImageAds: "user/delete-image-ads/{id}",
DeleteAdvertisement:"user/products/delete-ad/{id}",
// Profile
ShowProfile: "user/show-profile",
UpdateProfile: "user/update-profile",
// un token

//payment
PaymentgateWay:"https://ksa.paymob.com/v1/intention"


};

export default BuyerServicesUrl;